import { render, staticRenderFns } from "./updateOperatorLinkageDesc.vue?vue&type=template&id=31359a60&lang=pug"
import script from "./updateOperatorLinkageDesc.vue?vue&type=script&lang=js"
export * from "./updateOperatorLinkageDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports